import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCommunications from './communications.reducer';
import { ManagementModuleState } from '..';

export interface CommunicationState {
  communications: fromCommunications.State;
}

const selectManagementModuleState = createFeatureSelector<ManagementModuleState>('management');

const selectCommunicationsState = createSelector(selectManagementModuleState, (state: ManagementModuleState) => state?.communications);

//
// Organization Channels
//
export const selectOrganizationChannelQueryParams = createSelector(
  selectCommunicationsState,
  fromCommunications.getOrganizationChannelQueryParams
);
export const selectOrganizationChannels = createSelector(selectCommunicationsState, fromCommunications.getOrganizationChannels);

//
// Configured Channels
//
export const selectConfiguredChannels = createSelector(selectCommunicationsState, fromCommunications.getConfiguredChannels);
export const selectConfiguredChannelQueryParams = createSelector(
  selectCommunicationsState,
  fromCommunications.getConfiguredChannelQueryParams
);
export const selectTopoEmailEditIsActive = createSelector(selectCommunicationsState, fromCommunications.getTopoEmailEditIsActive);
export const selectSendGridEmailEditIsActive = createSelector(selectCommunicationsState, fromCommunications.getSendGridEmailEditIsActive);
export const selectEverbridgeEditIsActive = createSelector(selectCommunicationsState, fromCommunications.getEverbridgeEditIsActive);
export const selectSlackEditIsActive = createSelector(selectCommunicationsState, fromCommunications.getSlackEditIsActive);
export const selectMicrosoftTeamsEditIsActive = createSelector(selectCommunicationsState, fromCommunications.getMicrosoftTeamsEditIsActive);
export const selectTwilioEditIsActive = createSelector(selectCommunicationsState, fromCommunications.getTwilioEditIsActive);
export const selectSelectedConfiguredChannel = createSelector(selectCommunicationsState, fromCommunications.getSelectedConfiguredChannel);
export const selectSelectedConfiguredChannelToDelete = createSelector(
  selectCommunicationsState,
  fromCommunications.getSelectedConfiguredChannelToDelete
);
export const selectSlackChannelsForConfiguredChannel = createSelector(
  selectCommunicationsState,
  fromCommunications.getSlackChannelsForConfiguredChannel
);
export const selectIsLoading = createSelector(selectCommunicationsState, fromCommunications.getIsLoading);

//
// Distribution Lists
//
export const selectDistributionListsQueryParams = createSelector(
  selectCommunicationsState,
  fromCommunications.getDistributionListsQueryParams
);
export const selectDistributionLists = createSelector(selectCommunicationsState, fromCommunications.getDistributionLists);
export const selectDistributionListNewIsActive = createSelector(
  selectCommunicationsState,
  fromCommunications.getDistributionListNewIsActive
);
export const selectSelectedDistributionList = createSelector(selectCommunicationsState, fromCommunications.getSelectedDistributionList);
export const selectSelectedDistributionListToDelete = createSelector(
  selectCommunicationsState,
  fromCommunications.getSelectedDistributionListToDelete
);
export const selectDistributionListDataQueryParams = createSelector(
  selectCommunicationsState,
  fromCommunications.getDistributionListDataQueryParams
);
export const selectDistributionListDataDocuments = createSelector(
  selectCommunicationsState,
  fromCommunications.getDistributionListDataDocuments
);

//
// Templates
//
export const selectTemplateQueryParams = createSelector(selectCommunicationsState, fromCommunications.getTemplateQueryParams);
export const selectTemplates = createSelector(selectCommunicationsState, fromCommunications.getTemplates);
export const selectTemplateNewIsActive = createSelector(selectCommunicationsState, fromCommunications.getTemplateNewIsActive);
export const selectSelectedTemplate = createSelector(selectCommunicationsState, fromCommunications.getSelectedTemplate);
export const selectSelectedTemplateToDelete = createSelector(selectCommunicationsState, fromCommunications.getSelectedTemplateToDelete);
export const selectTemplateCopyIsActive = createSelector(selectCommunicationsState, fromCommunications.getTemplateCopyIsActive);
export const selectSelectedTemplateToCopy = createSelector(selectCommunicationsState, fromCommunications.getSelectedTemplateToCopy);
export const selectEverbridgeTemplates = createSelector(selectCommunicationsState, fromCommunications.getEverbridgeTemplates);
//
// Datasets
//
export const selectCommunicationCenterDataset = createSelector(selectCommunicationsState, fromCommunications.getCommunicationCenterDataset);
